module.exports = __webpack_public_path__ + "img/896-63159a.png";